<template>
<div>
<b-row>
  <h3 class="text-info ml-4">Sample Images</h3>
  <!-- <button> </button> -->
        <b-button
        variant="link"
       @click="downloadWithAxios('https://covidcare-fec86.web.app/img/normal.2b94388c.jpg')"
        :class="{'btn-xs float-right py-0 ml-4': true}"
      >
      Normal Xray
        <!-- <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span> -->
      </b-button>

        <b-button
        variant="link"
@click="downloadWithAxios('https://covidcare-fec86.web.app/img/covid.523c8b16.jpeg')"  
      :class="{ 'btn-xs float-right py-0': true}"
      >
      Covid Xray
        <!-- <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span> -->
      </b-button>
              <b-button
        variant="link"
@click="downloadWithAxios('https://covidcare-fec86.web.app/img/pneumonia.1be31c4c.jpeg')"       
  :class="{ 'btn-xs float-right py-0': true}"
      >
      Pneumonia Xray
        <!-- <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span> -->
      </b-button>
      <b-col sm="12" md="12">
        <Widget
          title="<h3><b><large class='text-muted'>Upload To Get Result</large></b></h3>"
          customHeader close collapse
        >
          <div class="widget-padding-md w-100 h-100 text-left border rounded">
            <b-row>
                
            
              <b-col v-if="className!=''" sm="12" md="12">
                          <b-tooltip

                   <span  @click="refresh"
            class="refresh glyphicon glyphicon-refresh"
          />
          
                 <h3 class="text-danger" v-if="className=='COVID_19'">You have symptoms of COVID-19</h3>
                 <h3 class="text-info" v-if="className=='NORMAL'">You are Healthy</h3>
                 <h3 class="text-warning" v-if="className=='Pneumonia'">You have symptoms of {{className}}</h3>

                  <h3>Prediction is {{score *100}}% Accurate</h3>
                           <b-col class="mt--3" sm="3"  v-if="className=='NORMAL'">
        <img height="300" width="300" src="../assets/healthy.png" alt="">
                           </b-col>
           <b-col class="mt--3" sm="3"  v-else>
        <img height="300" width="300" src="../assets/notwell.png" alt="">
                 </b-col>
              </b-col>
       
              <b-col v-else-if="loader">
                            <ring-loader  :color="red" :size="size"></ring-loader>

              </b-col>

              <b-col sm="6" v-else>
                    <input @change="handleImage" class="custom-input" type="file" accept="image/*">

              </b-col>
              <b-col class="mt--3" sm="3" v-if="className== '' & loader == false">
        <img src="@/assets/xray.png" alt="">
                 </b-col>
            </b-row>
          </div>

        </Widget>
      </b-col>
</b-row>



</div>

</template>

<script>
import axios from 'axios'
import Widget from '@/components/Widget/Widget';
import RingLoader from "@/components/RingLoader.vue";

export default {
    name:"upload",
    components: {Widget,RingLoader},
    data() {
        return {
            image: '',
            remoteUrl:"",
            className:"",
            score:0.0,
            loader:false
        }
    },
    methods: {
        refresh() {
            this.className = ""
            this.score = 0
        },
        handleImage(e) {
            const selectedImage = e.target.files[0]
            this.createBase64Image(selectedImage)
            this.loader= true
        },
        async createBase64Image(fileObj) {
            const reader = new FileReader()
            reader.onload = (e) => {
                this.image = e.target.result
                this.uploadImage()
            }
             reader.readAsDataURL(fileObj)
        },
        async uploadImage() {
            const {image} =  this
            // http://localhost:5001/shell-hacks-31d0a/us-central1/app/upload'
// http://localhost:5000/covidcare-fec86/us-central1/app
            axios.post('https://us-central1-covidcare-fec86.cloudfunctions.net/app/upload',{image}).then(res => {
                this.className=res.data.class
                this.loader = false
                if (this.className == 'COVID_19') {
                    this.addErrorNotification()
                }
                else if (this.className == 'NORMAL') {
                    this.addSuccessNotification()
                } else {
                    this.addInfoNotification()
                }
                this.score=res.data.score.toFixed(2)
            }).catch(err=>{
                  this.loader = false
                  this.$toasted.error('Error in getting result', {
                    action: [
                      {
                        text: 'Cancel',
                        onClick: (e, toastObject) => {
                                      toastObject.goAway(0);
                        }
                      }
                    ]
                  });
                console.error("Error in uploading file",err)
            })
        },
        addErrorNotification() {
      this.$toasted.error('You need Immediate Medical Attention.', {
        action: [
          {
            text: 'Cancel',
            onClick: (e, toastObject) => {
                          toastObject.goAway(0);
            }
          }
        ]
      });
    },
    addSuccessNotification() {
      this.$toasted.success('You are Healthy', {
        action: {
          text: 'Close',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        }
      })
    },
        addInfoNotification() {
      this.$toasted.info('You need Medical Attention', {
        action: {
          text: 'Cancel launch',
          onClick: (e, toastObject) => {
                          toastObject.goAway(0);

          }
        }
      });
    },
    
 downloadWithAxios(url){
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      })
      .then(response => {
        
        this.forceFileDownload(response)
        
      })
      .catch(() => console.log('error occured'))
    },
     forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.png') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    }
}
</script>

<style  scoped>
.refresh{
    float: right;
    height: 50px;
    width: 50px
    
}
.glyphicon {
  font-size: 25px;
}
</style>